"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $http;
var $injector = angular.injector(['ng']);
$injector.invoke(['$http', function (_$http_) {
        $http = _$http_;
    }]);
exports.default = $http;
